import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { BanDo } from './bando/BanDo';
import { SelectHuyenMulti } from '../shared/selecthuyenmulti/SelectHuyenMulti';
import { Menu } from './menu/Menu'
import Autocomplete from 'react-autocomplete';
import TimKiemApi from '../api/TimKiemApi';

export const PublicBanDo = () => {
    const [urlFunction, setUrlFunction] = useState({});
    const [printMap, setPrintMap] = useState(0);
    const [listFilters, setListFilter] = useState([]);
    const [valueFilter, setValueFilter] = useState('');
    const [toaDoX, setToaDoX] = useState(null);
    const [toaDoY, setToaDoY] = useState(null);
    const [toaDo, setToaDo] = useState([]);
    var requestTimer = null;
    const [geomjson, setGeomjson] = useState('');
    const [listHuyens, setListHuyen] = useState([]);
    const [khuyenCaoPhanBon, setKhuyenCaoPhanBon] = useState(0);

    const onPrint = () => {
        setPrintMap(printMap + 1);
    }

    const getIdHuyen = (listHuyens) => {
        setListHuyen(listHuyens)
    }

    // function flyTo(localtion, zoomNew) {
    //     let duration = 2000;
    //     let parts = 2;
    //     let called = false;
    //     function callback(complete) {
    //         --parts;
    //         if (called) {
    //             return;
    //         }
    //         if (parts === 0 || !complete) {
    //             called = true;
    //         }
    //     }
    //     map.getView().animate(
    //         {
    //             center: localtion,
    //             duration: duration
    //         },
    //         callback
    //     );
    //     map.getView().animate(
    //         {
    //             zoom: zoomNew - 1,
    //             duration: duration / 2
    //         },
    //         {
    //             zoom: zoomNew,
    //             duration: duration / 2
    //         },
    //         callback
    //     )
    // }

    const localtion = useLocation();
    useEffect(() => {
        setPrintMap(0);
        setKhuyenCaoPhanBon(0);
    }, [localtion.pathname]);

    const clickMenu = (e) => {
        setUrlFunction(e);
    }
    // const timKiemThon = (geomjson) =>{
    //     if (geomjson !== '') {
    //         const local = JSON.parse(geomjson);
    //         flyTo(local.coordinates, 15);
    //     }
    // }
    const clickKhuyenCaoPhanBon = () => {
        setKhuyenCaoPhanBon(khuyenCaoPhanBon + 1);
    }
    const onChangeToaDoX = (event) => {
        setToaDoX(event.target.value)
    }
    const onChangeToaDoY = (event) => {
        setToaDoY(event.target.value)
    }
    const diDen = () =>{
        if(toaDoX != null && toaDoY != null){
            setToaDo([parseFloat(toaDoX), parseFloat(toaDoY)]);
        }
    }
    return (
        <div id="wrapper" className="public">
            <Menu clickMenu={(e) => clickMenu(e)}></Menu>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-1 static-top shadow">
                        <div className="col-md-3">
                            <SelectHuyenMulti onChangeHuyenProps={(e) => getIdHuyen(e)}></SelectHuyenMulti>
                        </div>
                        <div className="input-group col-md-3">
                            <Autocomplete
                                inputProps={{ id: 'states-autocomplete', className: 'form-control', placeholder: "Tên địa danh" }}
                                wrapperStyle={{ position: 'relative', display: 'inline-block', zIndex: 999, width: "100%" }}
                                value={valueFilter}
                                items={listFilters}
                                getItemValue={(item) => item.tenthon}
                                onSelect={(value, item) => {
                                   
                                    setGeomjson(item.geomjson);
                                    setValueFilter(value);
                                }}
                                onChange={(event, value) => {
                                    setValueFilter(value);
                                    clearTimeout(requestTimer)

                                    requestTimer = TimKiemApi.getFilter({ listHuyens: listHuyens.map(x => x.Ma).join(','), filter: value }).then((response) => {
                                        setListFilter(response);
                                    });
                                }}
                                renderItem={(item, isHighlighted) => (
                                    <div
                                        className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
                                    >{item.tenthon}</div>
                                )}
                            />
                            <div className="input-group-append">
                                <i class="fas fa-search tk-ban-do"></i>
                            </div>
                        </div>
                        <div className="col-md-3 toa-do">
                            <div className="col-5">
                                <input type="number" className="form-control" placeholder="Tọa độ X" value={toaDoX} onChange={onChangeToaDoX} />
                            </div>
                            <div className="input-group col-7">
                                <input type="number" className="form-control" placeholder="Tọa độ Y" value={toaDoY} onChange={onChangeToaDoY} />
                                <div className="input-group-append">
                                    <button className="btn btn-info" type="button" onClick={diDen}><i className='fas fa-map-marker-alt'></i> Đi đến</button>
                                </div>
                            </div>
                        </div>
                        <ul className="navbar-nav ml-auto">
                            <div className="topbar-divider d-none d-sm-block ngan-cach"/>
                            <li>
                                <button type="button" className="btn btn-info btn-sm" onClick={clickKhuyenCaoPhanBon}>
                                    <i class="fas fa-tachometer-alt"></i> Phân bón
                                </button>   
                            </li>
                            <div className="topbar-divider d-none d-sm-block  ngan-cach" />
                            <li>
                                <button type="button" className="btn btn-info btn-sm" onClick={onPrint}>
                                    <i class="fas fa-print"></i>
                                </button>
                            </li>
                            <div className="topbar-divider d-none d-sm-block ngan-cach" />
                            <li>
                                <a href="/login" class="btn btn-info btn-sm btn-dang-nhap">
                                    <span class="text">Đăng nhập</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <div className="container-fluid">
                        <BanDo urlFunction={urlFunction} listHuyens={listHuyens} showPhanBon={khuyenCaoPhanBon} geomjson={geomjson} printMap={printMap} toaDo={toaDo}></BanDo>
                    </div>
                </div>
            </div>
        </div>
    )
}
